<script setup lang="ts">
import { computed } from "vue"
import { useHead } from "@unhead/vue"
import auth from "../auth/keycloak"
import { useAllPrivileges } from "../privileges"
import NFansLogoInvert from "../components/NFansLogoInvert.vue"
import wallpaperUrl from "../assets/login-wallpaper-hd.png"

useHead({ title: "Anmelden" })

const allPrivileges = useAllPrivileges()

const hasAnyRole = computed(() => allPrivileges.value.some(auth.hasRole))

const fullName = computed(() => {
  const p = auth.userProfile.value ?? {}
  return [p.firstName, p.lastName].filter(Boolean).join(" ").trim()
})
const preferredUsername = computed(() => auth.userProfile.value?.username ?? "")

function login() {
  auth.login()
}
function logout() { auth.logout() }
</script>

<template>
  <div
    class="min-h-screen min-h-dvh bg-center bg-cover flex items-center justify-center p-4"
    :style="{ backgroundImage: `url('${wallpaperUrl}')` }"
  >
    <div
      class="w-full max-w-sm rounded-box p-8 shadow-2xl border border-white/30
             bg-base-100/15 backdrop-blur-xl text-white"
    >
      <NFansLogoInvert class="h-16 w-auto mx-auto mb-6" title="NFans Admin" />
      <h1 class="text-2xl font-bold text-center mb-6">Melde dich an</h1>

      <div v-if="!hasAnyRole" class="space-y-4">
        <p class="text-center text-sm">
          Sorry <em>{{ fullName || preferredUsername }}<span v-if="fullName"> ({{ preferredUsername }})</span></em>,<br>
          aber du hast nicht genug Rechte.
        </p>
        <button
          type="button"
          class="btn btn-ghost btn-block text-white"
          data-testid="login-logout"
          @click="logout"
        >Abmelden</button>
      </div>
      <button
        v-else
        type="button"
        class="btn btn-primary btn-block"
        data-testid="login-sso"
        @click="login"
      >
        Mit NintendoFans.de SSO anmelden
      </button>
    </div>
  </div>
</template>

<style scoped>
/* Progressive-enhancement fallback: if the browser does not support backdrop-filter,
   fall back to a more opaque card so the content stays readable. */
@supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
  div[class*="backdrop-blur"] {
    background-color: rgb(var(--color-base-100) / 0.85);
    color: inherit;
  }
}
</style>
